"use client";

import Card from "@/components/atoms/Card";
import styles from "./NavWithScrollLandingPageMBA.module.scss";
import { useEffect, useRef, useState } from "react";
import cn from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { GAEvent, GA_EVENTS } from "@/helpers/gaEvents";

export default function NavWithScrollLandingPageMBA({
  data,
  isMobile,
  targets,
  CTA,
  isProgramDetailsPage,
  isCampusImmersionPage = false,
  programName = "",
  programType = "",
  duration = "",
  overview = "",
  programHighlights = [],
  Specialization = [],
  EligibilityCriteria = [],
  FEES = [],
  CareerImpact = [],
  Faculty = [],
  isRFIDisabled = false
}: {
  data: { enabled: boolean; text: string, ckrich: string }[];
  isMobile?: boolean;
  targets: any;
  CTA: any,
  isProgramDetailsPage: boolean
  isCampusImmersionPage?: boolean;
  programName: string;
  programType: string;
  duration: string;
  overview: string;
  programHighlights: [];
  Specialization: any;
  EligibilityCriteria: any;
  FEES: any;
  CareerImpact: any;
  Faculty: any;
  isRFIDisabled: boolean
}) {
  const targetsOptions = Object.values(targets).map((e: any) =>
    e.toLowerCase()
  );
  const [selectedLink, setSelectedLink] = useState<string>(targetsOptions[0]);
  const isRunning = useRef(false);

  function toggleSelectedLink(e: any, text: string, scrollTo) {
    setSelectedLink(text?.toLowerCase());
    const el = document.getElementById(scrollTo);
    if(!el) return;
    const yOffset = -100;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }


  const handleScroll = () => {
    if (isRunning.current) return;
    isRunning.current = true;
    const navlist = data?.filter((x) => x?.enabled)?.map((item) => item.ckrich)
    navlist.forEach((sec: string) => {
      let top = window.scrollY+12;
      const navTab = document?.getElementById(`#${sec}`)
      const tabContent = document.getElementById(sec)
      if (tabContent !== null && navTab !== null) {
        let offset = tabContent.offsetTop;
        let height = tabContent.offsetHeight;
        const totalArea = (offset + height)
        if (top > offset && top < totalArea) {
          if (!navTab.classList.contains(styles.NavWithScroll__selectedLink)) {
            navTab.classList.add(styles.NavWithScroll__selectedLink)
            const offSetLeft = navTab.offsetLeft
            setTimeout(() => {
              navTab.parentElement.scrollTo(offSetLeft, 0)
            }, 1000)
          }
        } else {
          navTab.classList.remove(styles.NavWithScroll__selectedLink)
        }
      } else if (!tabContent && navTab !== null) {
        navTab.classList.remove(styles.NavWithScroll__selectedLink)
      }
    });
     setTimeout(() => {
    isRunning.current = false;
  }, 200);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])
  const { LEAD_INITIATE } = GAEvent
  const sendGAEvents = ({ text }) => {

    pushToDataLayer({
      'event': 'sub_navigation_bar_interaction',
      'cta_text': text,
      'page_type': getGlobalStateValue('pageType')
    });

    if (isProgramDetailsPage) {

      const webEnagageEnums = sendWebEngageEnum(text.trim().toLocaleUpperCase());

      window?.webengage?.track(`Program Menu - ${text.trim()} Clicked`, webEnagageEnums)
    }

  }

  const extractNumber = (input) => {
    const match = input.match(/\d+/g); // Extracts all numbers found in the string
    return match ? String(match.join('')) : null;
  }


  const sendWebEngageEnum = (text) => {

    let totalSemester = "";

    const totalSemesterMatch = overview?.match(/(\d+)\s*semester/i);


    if (totalSemesterMatch) {
      totalSemester = totalSemesterMatch[1];
    } else {
      console.log("Not found");
    }


    const newSpecialization = Specialization.map(({ attributes }) => (attributes?.Title?.text)).join(", ")

    const perSemesterFee = FEES.filter(({ SecondaryHeading }) => SecondaryHeading.toLocaleUpperCase().includes("PER SEMESTER FEE"));
    const fullProgramFee = FEES.filter(({ SecondaryHeading }) => SecondaryHeading.toLocaleUpperCase().includes("FULL PROGRAM FEE"));

    switch (text) {
      case "OVERVIEW":

        return {
          "Program Name": programName,
          "Program Type": programType,
          "Total Semesters": totalSemester,
          "Number of Years": extractNumber(duration)
        }

      case "PROGRAM HIGHLIGHTS":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Highlights": programHighlights,
          "Number of Years": duration
        }

      case "CURRICULUM":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Total Semesters": totalSemester,
          "Specialization": newSpecialization,
          "Number of Years": extractNumber(duration)
        }

      case "DEGREE OFFERED":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Total Semesters": totalSemester,
          "Specialization": newSpecialization,
        }
      case "SPECIALIZATION":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Total Semesters": totalSemester,
          "Specialization": newSpecialization,
        }
      case "SPECIALIZATION":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Total Semesters": totalSemester,
          "Specialization": newSpecialization,
        }
      case "ELIGIBILITY":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Elegebility Criateria for Indian Student": EligibilityCriteria[0]?.Content,
          "Elegebility Criateria for International Student": EligibilityCriteria[1]?.Content,
          "Number of Years": extractNumber(duration)
        }
      case "FEES":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "EMI Amount": extractNumber(FEES[0]?.Heading || ""),
          "EMI Tenure": extractNumber(FEES[0]?.SecondaryHeading || ""),
          "Per Semester Fees": perSemesterFee[0]?.FeesInInr,
          "Full Program Fees": fullProgramFee[0]?.FeesInInr
        }
      case "CAREERS":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Services": CareerImpact
        }
      case "FACULTY":
        return {
          "Program Name": programName,
          "Program Type": programType,
          "Faculty": Faculty?.map(({ attributes }) => attributes.Name).join(', ')
        }

      default:
        { }
    }


  }


  const NavMenu = (
    <nav className="relative">
      <ul
        className={cn(
          styles.NavWithScroll__listContainer,
          "flex",
          "gap-6",
          "items-center",
          "sm:justify-around",
          "uppercase",
          "font-raleway",
          "text-primary-blue",
          "overflow-x-scroll",
        )}
      >
        {data
          ?.filter((x) => x?.enabled)
          ?.map((item, index) => {
            const hashIndex = targetsOptions.indexOf(
              item.text?.split(" ").join("").toLowerCase()
            );

            return (
              <li
                key={index}
                id={`#${item?.ckrich}`}
                className={
                  selectedLink == item.text?.toLowerCase()
                    ? styles.NavWithScroll__selectedLink
                    : ""
                }
                onClick={(e) => {
                  sendGAEvents({ text: item.text });
                  toggleSelectedLink(
                    e,
                    item.text?.toLowerCase(),
                    item?.ckrich
                  );
                }}
              >
                {item.text}
              </li>
            );
          })}
        {isProgramDetailsPage && !isRFIDisabled && <li className={styles.cta}>
                    
                  <CommonButton
                  id = "Secondary-applynow"
                    isEventOnly={true}
                    GADataNew={
                      {
                        ...GA_EVENTS.get(LEAD_INITIATE),
                        cta_text: 'Apply Now',
                        section_name: "middle" ,
                        header_title:   "NA",
                        page_type: "Home Page",
                        page_url: true,
                      }
                     }
                    type={CTA?.url === "#" ? "button" : "link"}
                    href={CTA.url}
                    modalType={CTA.modalType}
                    modalData={{  associatedPrograms: CTA?.associatedPrograms || [], isLandingPage: true, isNewLeadForm: true}}
                    className={cn(styles.ctaBtn, "whitespace-nowrap")}
                    bg={"bl"}
                    color={"o"}
                    pageType="origin"
                  >
                    Enquire Now
                  </CommonButton>
                    
                    </li>}
                  
                {!isMobile && isCampusImmersionPage && <li className={styles.cta}>
                  <CommonButton
                    isEventOnly={true}
                    GADataNew={null}
                    CTATarget={`${CTA.target}`}
                    type={CTA?.url === "#" ? "button" : "link"}
                    href={CTA.url}
                    modalType={CTA.modalType}
                    modalData={{  associatedPrograms: CTA?.associatedPrograms || [], isLandingPage: true, isNewLeadForm: true}}
                    className={isCampusImmersionPage ? CTA.CustomStyle: styles.ApplyNow_Custom}
                    color={isCampusImmersionPage?'g':'y'}
                    size={isCampusImmersionPage?'ciip':'l'}
                    pageType="origin"
                  >
                   Enquire Now
                  </CommonButton>
                </li>}
       
      </ul>
    </nav>
  );

  return (
    <Card shadow={false} extraClasses={styles.NavWithScroll__cardContainer}>{NavMenu}</Card>
  );
}
